<template>
  <div class="facet">
    <div class="facet-toggle">
      <span>{{ $texts('search.inTheVicinityOf', 'In the vicinity of') }}</span>
    </div>
    <div class="facet-terms">
      <FieldSelect v-model="value" :options="options" class="is-small" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { FieldSelectOption } from '~/components/Field/Select/types'
import type { LocationFilter } from '~/layers/legacy-search/types'

const props = withDefaults(
  defineProps<{
    locations: LocationFilter[]
  }>(),
  {
    locations: () => [],
  },
)

const route = useRoute()
const router = useRouter()
const { $texts } = useEasyTexts()

const value = computed({
  get() {
    // @TODO: getQueryParamString needs to be migrated
    return String(route.query.location || 'none')
  },
  set(location: string) {
    const query: Record<string, string> = { ...route.query, location }
    delete query.sort
    delete query.page

    if (location === 'none') {
      delete query.location
    }

    router.push({
      name: route.name || '',
      query,
    })
  },
})

const options = computed<FieldSelectOption[]>(() => [
  {
    value: 'none',
    label: '----------',
  },
  ...props.locations.map((v) => ({
    value: v.id,
    label: v.title,
  })),
])
</script>
